export default __webpack_public_path__ + "static/media/contact-dark.3fd15143.svg";